import { KubernetesAiSavingsOpportunity } from "@/services/cloudchipr.api";
import { getResourceDetailsFromKubernetesAiSavingsOpportunity } from "@/store/ai-kubernetes-recommendations/utils/helpers/getResourceDetailsFromKubernetesAiSavingsOpportunity";
import { getResourceDetailsTargetFromKubernetesAiSavingsOpportunity } from "@/store/ai-kubernetes-recommendations/utils/helpers/getResourceDetailsTargetFromKubernetesAiSavingsOpportunity";
import { ResourceDetailsActiveTab } from "@/store/resource-details/utils/types/common";
import { InitiateResourceDetailsDrawerThunkArgs } from "@/store/resource-details/thunks/initiateResourceDetailsDrawerThunk";

export const getInitiateResourceDetailsDrawerThunkArgsFromAiKubernetesOpportunity =
  (
    opportunity: KubernetesAiSavingsOpportunity,
    enableBillingCostAndForecastedEOMForOpportunities?: boolean,
  ): InitiateResourceDetailsDrawerThunkArgs | undefined => {
    if (!opportunity.resource_id) {
      return;
    }
    const resourceType = opportunity.service;
    const details = getResourceDetailsFromKubernetesAiSavingsOpportunity(
      opportunity,
      enableBillingCostAndForecastedEOMForOpportunities,
    );
    const target =
      getResourceDetailsTargetFromKubernetesAiSavingsOpportunity(opportunity);

    const availableTabs: ResourceDetailsActiveTab[] = ["general"];

    if (resourceType !== "kubernetes_pod") {
      availableTabs.push("costs");
    }

    availableTabs.push("ai-kubernetes-opportunities");

    return {
      openedFrom: "savingsOpportunities",
      availableTabs,
      tags: { loading: false, tags: opportunity.tags ?? [] },
      resource: target,
      resourceAdditionalDetails: { details },
    };
  };
